import React from 'react'
import { Form } from 'semantic-ui-react'

const RadioButtons = (props) => (
    <Form.Group inline>
    <label>{props.label}
      <span className='requiredAsterisk'> *</span>
    </label>
    {props.options.map(option => (
      <Form.Radio
        checked={props.value === option}
        label={option}
        name={props.name}
        onChange={props.changeHandler}
        value={option}
      />
    ))}

  </Form.Group>
)

export default RadioButtons